import React, {Component} from "react";
import countries from "../../../assets/country_codes";

export class TableFilter extends Component {
    drugsGroups = {
        "A": "Alimentary tract and metabolism",
        "B": "Blood and blood forming organs",
        "C": "Cardiovascular system",
        "D": "Dermatologicals",
        "G": "Genito-urinary system and sex hormones",
        "H": "Systemic hormonal preparations, excluding sex hormones and insulins",
        "J": "Antiinfectives for systemic use",
        "L": "Antineoplastic and immunomodulating agents",
        "M": "Musculo-skeletal system",
        "N": "Nervous system",
        "P": "Antiparasitic products, insecticides and repellents",
        "R": "Respiratory system",
        "S": "Sensory organs",
        "V": "Various"
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            atcGroup: "",
            country: "",
            activeSubstance: "",
            manufacturer: "",
            brandName: "",
            genericName: ""
        };
    }

    onATCChange = (event) => {
        let {value} = event.target;
        this.setState({"atcGroup": value});
        this.props.onATCSelect(value)
    };

    onCountryChange = (event) => {
        let {value} = event.target;
        this.setState(() => {
            return {
                ...this.state,
                "country": value
            }
        });
        this.props.onCountrySelect(value)
    };

    onActiveSubstanceChange = (event) => {
        let {value} = event.target;
        this.setState({activeSubstance: value});
        this.props.setActiveSubstance(value);
    };

    onManufacturerChange = (event) => {
        let {value} = event.target;
        this.setState({manufacturer: value});
        this.props.setManufacturer(value);
    };

    onBrandNameChange = (event) => {
        let {value} = event.target;
        this.setState({brandName: value});
        this.props.setBrandName(value);
    };

    onGenericNameChange = (event) => {
        let {value} = event.target;
        this.setState({genericName: value});
        this.props.setGenericName(value);
    };

    handleKeyPress = e => {
        if (e.key === 'Enter') {
            this.props.applyFilter();
        }
    };

    renderAtcGroups = () => {
        return Object.keys(this.drugsGroups).map(key => {
            return <option key={key} value={key}>{this.drugsGroups[key]}</option>
        })
    };

    renderCountries = () => {
        if (this.props.coveredCountries) {
            return this.props.coveredCountries.map(countryCode => {
                return <option key={countryCode} value={countryCode}>{countries[countryCode]}</option>
            })
        }
        return null;
    };

    render() {
        return (
            <div className='ibox'>
                <div className={"bg-success card-header text-light d-flex"}>
                    <h4 className="font-weight-bold">Table Filter</h4>
                    <button className="btn btn-light text-success ml-auto font-weight-bold my-auto" type="button"
                            data-toggle="collapse"
                            data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                        Expand
                    </button>
                </div>
                <div className="collapse ibox-content" id="collapseExample">
                    <div className={"row px-5 py-3"}>
                        <div className={"form-group col-4"}>
                            <label htmlFor={"active-substance"}>Active Substance</label>
                            <input name={"activeSubstance"}
                                   id={"active-substance"}
                                   className={"form-control"}
                                   value={this.state.activeSubstance}
                                   onChange={this.onActiveSubstanceChange}
                                   onKeyPress={this.handleKeyPress}
                            />
                        </div>
                        <div className={"form-group col-4"}>
                            <label htmlFor={"country-code"}>Country</label>
                            <select name={"country"}
                                    id={"country-code"}
                                    className={"form-control"}
                                    value={this.state.country !== "None" ? this.state.country : ""}
                                    onChange={this.onCountryChange}
                            >
                                <option>None</option>
                                {this.renderCountries()}
                            </select>
                        </div>
                        <div className={"form-group col-4"}>
                            <label htmlFor={"atc-code"}>ATC Group</label>
                            <select name={"atcGroup"}
                                    id={"atc-code"}
                                    className={"form-control"}
                                    value={this.state.atcGroup !== "None" ? this.state.atcGroup : ""}
                                    onChange={this.onATCChange}
                            >
                                <option>None</option>
                                {this.renderAtcGroups()}
                            </select>
                        </div>
                    </div>
                    <div className={"row px-5 py-3"}>
                        <div className={"form-group col-4"}>
                            <label htmlFor={"manufacturer"}>Manufacturer</label>
                            <input name={"manufacturer"}
                                   id={"manufacturer"}
                                   className={"form-control"}
                                   value={this.state.manufacturer}
                                   onChange={this.onManufacturerChange}
                                   onKeyPress={this.handleKeyPress}
                            />
                        </div>
                        <div className={"form-group col-4"}>
                            <label htmlFor={"brand-name"}>Brand Name</label>
                            <input name={"brandName"}
                                   id={"brand-name"}
                                   className={"form-control"}
                                   value={this.state.brandName}
                                   onChange={this.onBrandNameChange}
                                   onKeyPress={this.handleKeyPress}
                            />
                        </div>
                        <div className={"form-group col-4"}>
                            <label htmlFor={"generic-name"}>Brand Name</label>
                            <input name={"genericName"}
                                   id={"generic-name"}
                                   className={"form-control"}
                                   value={this.state.genericName}
                                   onChange={this.onGenericNameChange}
                                   onKeyPress={this.handleKeyPress}
                            />
                        </div>
                    </div>
                    <div className={"text-right"}>
                        <button className={"btn btn-success font-weight-bold"}
                                onClick={this.props.applyFilter}
                        >
                            Apply filter
                        </button>

                    </div>
                </div>

            </div>
        );
    }


}
